/**
 * @file cart popup
 *
 * Javascript documentation : http://usejsdoc.org/
 */

/**
 *
 * @type {{bindAll: Function, bindCartPop: Function, refreshMiniCart: Function}}
 */
ACC.cartpopup = {
    bindAll: function () {
        this.bindCartPop();
    },

    bindCartPop: function () {
        $('#cart_header').on('click', function (e) {
            $('#cart_popup').hide();
            $.ajax({
                url: rolloverPopupUrl,
                cache: false,
                type: 'GET'
            }).done( function (result) {
                $('#rollover_cart_popup').html(result);
                if($('#rollover_cart_popup .slimScrollActive').length > 0) {
                  $('#rollover_cart_popup .scroll .nice-scrollable').css('max-height','270px');
                  var ps = new PerfectScrollbar('#rollover_cart_popup .scroll .nice-scrollable', {
                    suppressScrollX: true,
                    wheelPropagation: false
                  });
                  $("#rollover_cart_popup .slimScrollActive, #rollover_cart_popup .total-cart").on("touchstart ps-y-reach-end", function (event) {
                    if (event.cancelable) {
                      event.preventDefault();
                      event.stopPropagation();
                    }
                  });
                }
                $('#rollover_cart_popup').fadeIn();
            });
        });
    },

    refreshMiniCart: function () {
        $.get(refreshMiniCartUrl + Math.floor(Math.random() * 101) * (new Date().getTime()), function (result) {
            $('#minicart_data').html(result);
            if(result != "0") {
                $('#minicart_data').prop( "hidden", false );
            }else {
                $('#minicart_data').prop( "hidden", true );
            }
        });
    }
};

$(document).ready(function () {
    ACC.cartpopup.bindAll();
});

